import { Box } from "@material-ui/core";
import { TooltipProps } from "recharts";
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";
import { fontFamily } from "../../../../app/theme";
import { NumericFormat } from "react-number-format";
function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export const ConsumptionProductionTooltip = <TValue extends ValueType, TName extends NameType>({
  active,
  payload,
  label
}: TooltipProps<TValue, TName>) => {
  if (active && payload && payload.length) {
    return (
      <Box
        bgcolor={"#fff"}
        boxShadow={"0 5px 15px 0 rgba(0, 0, 0, 0.07), 0 15px 35px 0 rgba(50, 50, 93, 0.1)"}
        padding={"15px 10px"}
        fontSize={"10px"}
        style={{ outline: "none" }}
        border={"none"}
        fontWeight={500}
        fontFamily={fontFamily.Axiforma}
        color={"#4b5462"}
      >
        <Box>{label}</Box>
        <Box display={"flex"} alignItems={"center"}>
          <Box
            width={"6.5px"}
            height={"6.5px"}
            mr={"4px"}
            mb={"2px"}
            borderRadius={"50%"}
            border={"solid 1px rgba(70, 60, 87, 0.5)"}
            bgcolor={"rgba(22, 3, 55, 0.6)"}
          />
          {capitalizeFirstLetter(String(payload[1].name))} (
          <NumericFormat
            value={Number(payload[1].value)}
            displayType={"text"}
            decimalScale={0}
            fixedDecimalScale={true}
            thousandSeparator={true}
            suffix={"kWh"}
          />
          )
        </Box>
        <Box display={"flex"} alignItems={"center"}>
          <Box
            width={"6.5px"}
            height={"6.5px"}
            mr={"4px"}
            mb={"2px"}
            borderRadius={"50%"}
            border={"1px solid #eb9b81"}
            bgcolor={"rgba(251, 192, 173, 0.6)"}
          />
          {capitalizeFirstLetter(String(payload[0].name))} (
          <NumericFormat
            value={Number(payload[0].value)}
            displayType={"text"}
            decimalScale={0}
            fixedDecimalScale={true}
            thousandSeparator={true}
            suffix={"kWh"}
          />
          )
        </Box>
      </Box>
    );
  }

  return null;
};
